











import { editFactory } from '@/main/pages';

import { store } from './store/edit';
import { NAME, VERIFICATION_HISTORY_PARTS } from './constants';

export default editFactory(NAME, store).extend({
	data() {
		return {
			dependencies: {
				VERIFICATION_HISTORY_PARTS,
			},
		};
	},
});
